
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { AlButton } from '~/components/ui'

@Component({
  components: { AlButton },
})
export default class CheckAvailabilitySection extends Vue {
  @Prop({ required: true, default: '', type: String })
  private readonly title!: string

  @Prop({ required: true, default: '', type: String })
  private readonly to!: string

  @Prop({ required: true, default: '', type: String })
  private readonly btnText!: string
}
